import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";


const RelatedProductsContainer = styled.div`
    background-color: transparent;
    padding: 10%;
    height: 100%;
`;

const RelatedProducts: React.FC<WidgetProps> = props => {
    return (
        <RelatedProductsContainer>
            RELATED PRODUCTS GO HERE
        </RelatedProductsContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(RelatedProducts),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
